import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionBarSeparator = styled.div.attrs({
  id: 'descriptionBarSeparator',
})<React.CSSProperties>`
  background-color: ${Colors['light']};
  margin: 0 ${22 * Screen.widthRatio}px 0 ${22 * Screen.widthRatio}px;
  height: ${56 * Screen.widthRatio}px;
  width: ${3 * Screen.widthRatio}px;
`;

export default DescriptionBarSeparator;
